import {
  Box,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PrinterSettin } from "./settingApi";
import { setUserDetail } from "../../app/store/reducer";
import { update } from "./settingCustomApiHandler";
import DynamicBreadcrumbs from "../../common/Breadcrumb";
import { set } from "lodash";
import Heading from "../../common/Heading";

const Setting = () => {
  const filters = [
    { name: "2 inch printer ", value: "2" },
    { name: " 3 inch printer ", value: "3" },
  ];
  const userDetail = useSelector((state) => state.reducer.userDetail);
  const dispatch = useDispatch();
  const [spiltBills, setSpiltBills] = useState(false);
  const [settingPayload, setsettingPayload] = useState({
    myBusinessId: 0,
    type: "SIZE",
    value: userDetail.printerSize ? String(userDetail?.printerSize) : "3",
  });
  useEffect(() => {
    console.log("idby ", settingPayload.myBusinessId);
    if (settingPayload.myBusinessId === 0 && userDetail.myBusinessId) {
      // Update myBusinessId in settingPayload with the value from userDetail
      setsettingPayload((prevSetting) => ({
        ...settingPayload,
        myBusinessId: userDetail.myBusinessId,
      }));
    }
  }, [userDetail]);

  useEffect(() => {
    update(settingPayload, PrinterSettin, dispatch, setUserDetail, userDetail);
  }, [settingPayload]);
  return (
    <>
      {/* <DynamicBreadcrumbs /> */}
      <Box
        px={4}
        pb={4}
        container
        sx={{
          paddingTop: "15px",
          backgroundColor: "#E6E6FF",
          fontFamily: "'Montserrat', sans-serif",
          minHeight: "100vh",
        }}
      >
        <Heading name=" Printer Setting" />

        {/* <Grid
          item
          xs={12}
          sx={{
            background:
              "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
            padding: "10px",
            mt: "10px",
            borderRadius: "5px",
            color: "#01008B", // optional text color
            textAlign: "left",
            paddingLeft: "16px",
            marginBottom: "20px",
            fontFamily: "'Montserrat', sans-serif",
            fontSize: "20px",
            fontWeight: 500,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontSize: { xs: "14px", sm: "14px", md: "15px" },
            }}
          >
            Printer Setting
          </Typography>
        </Grid> */}

        <Grid
          item
          xs={12}
          sx={{
            backgroundColor: "#FFFFFF",
            padding: "16px",
            borderRadius: "8px",
            height: "50vh",
            marginBottom: "20px",
            fontFamily: "'Montserrat', sans-serif",
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth sx={{}}>
                <InputLabel
                  sx={{
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                  id="demo-simple-select-label"
                >
                  Select Printer
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  size="small"
                  id="demo-simple-select"
                  value={settingPayload.value}
                  label="Select Device"
                  onChange={(e) => {
                    console.log("SelectDevice ", e.target.value);
                    dispatch(
                      setUserDetail({
                        ...userDetail,
                        printerSize: e.target.value,
                      }),
                    );
                    setsettingPayload({
                      ...settingPayload,
                      value: e.target.value,
                    });
                  }}
                  sx={{
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  {filters.map((item, index) => {
                    return (
                      <MenuItem
                        sx={{
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        }}
                        value={item.value}
                        key={"option" + index}
                      >
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormGroup
                sx={{
                  height: "16px",
                  borderRadius: "4px",
                  border: "2px solid #5857b5",
                  // p: "7px",
                  pl: "16px",
                  pb: "22px",
                }}
              >
                <FormControlLabel
                  sx={{
                    justifyContent: "space-between",
                    m: 0,
                    flexDirection: "row-reverse",
                    "& .MuiFormControlLabel-label": {
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    },
                  }}
                  control={
                    <Switch
                      checked={settingPayload.value === "true" ? true : false}
                      onChange={(e) => {
                        setsettingPayload({
                          ...settingPayload,

                          value: String(e.target.checked),
                        });
                      }}
                    />
                  }
                  label="Print in Reginal language "
                  InputLabel={{
                    sx: { fontSize: { xs: "10px", sm: "12px", md: "15px" } },
                  }}
                />
              </FormGroup>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                size="small"
                label="Add Header Text"
                variant="outlined"
                onChange={(e) => {}}
                InputLabelProps={{
                  sx: { fontSize: { xs: "12px", sm: "13px", md: "15px" } },
                }}
                InputProps={{
                  sx: { fontSize: { xs: "12px", sm: "13px", md: "15px" } },

                  endAdornment: (
                    <SendIcon
                      sx={{
                        cursor: "pointer",
                        color: "primary.main",
                      }}
                      onClick={() => {
                        // Handle send icon click
                      }}
                    />
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Add Footer Text"
                size="small"
                variant="outlined"
                onChange={(e) => {}}
                InputLabelProps={{
                  sx: { fontSize: { xs: "12px", sm: "13px", md: "15px" } },
                }}
                InputProps={{
                  sx: { fontSize: { xs: "12px", sm: "13px", md: "15px" } },

                  endAdornment: (
                    <SendIcon
                      sx={{
                        cursor: "pointer",
                        color: "primary.main",
                      }}
                      onClick={() => {
                        // Handle send icon click
                      }}
                    />
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Add Terms And Conditions"
                size="small"
                variant="outlined"
                onChange={(e) => {}}
                InputLabelProps={{
                  sx: { fontSize: { xs: "12px", sm: "13px", md: "15px" } },
                }}
                InputProps={{
                  sx: { fontSize: { xs: "12px", sm: "13px", md: "15px" } },

                  endAdornment: (
                    <SendIcon
                      sx={{
                        cursor: "pointer",
                        color: "primary.main",
                      }}
                      onClick={() => {
                        // Handle send icon click
                      }}
                    />
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormGroup
                sx={{
                  height: "15px",
                  borderRadius: "4px",
                  border: "2px solid #5857b5",
                  // p: "7px",
                  pl: "16px",
                  pb: "22px",
                }}
              >
                <FormControlLabel
                  sx={{
                    justifyContent: "space-between",
                    m: 0,
                    flexDirection: "row-reverse",
                    "& .MuiFormControlLabel-label": {
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    },
                  }}
                  control={
                    <Switch
                      checked={spiltBills}
                      onChange={(e) => setSpiltBills(e.target.checked)}
                    />
                  }
                  label="Split Bills in Employee"
                />
              </FormGroup>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
export default Setting;
